import { View } from "@react-pdf/renderer";
import { ResumePDFText } from "components/Resume/ResumePDF/common";
import { TemplateTwoPDFSection, TemplateThreeEnhancedSection } from "./common";
import type { ResumeProfile } from "lib/redux/types";

export const Summary = ({
  profile,
  heading,
}: {
  profile: ResumeProfile;
  heading: string;
}) => {
  const { summary } = profile;

  return (
    <TemplateThreeEnhancedSection heading={heading}>
      <View>{summary && <ResumePDFText>{summary}</ResumePDFText>}</View>
    </TemplateThreeEnhancedSection>
  );
};
